import _ from 'lodash'
import { Module } from 'vuex'

import { RootState } from '../../types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { CouponState, initialCouponState } from './types'

export const coupon: Module<CouponState, RootState> =  {
  namespaced: true,
  state: _.cloneDeep(initialCouponState),
  actions,
  getters,
  mutations,
}
